import React from "react";
import { Link } from "react-router-dom";
import "./RecursoNoDisponible.css";

const RecursoNoDisponible = () => {
  const canClose = typeof window !== "undefined" && Boolean(window.opener);

  return (
    <div className="rnd-root">
      <div className="rnd-card">
        <h1 className="rnd-title">Contenido no disponible</h1>
        <p className="rnd-desc">
          Este recurso no está disponible en este momento. Puede que no tengas permiso para verlo o que el archivo aún no se haya publicado.
        </p>
        <div className="rnd-actions">
          <Link to="/usuario/campus" className="rnd-link">
            Volver al Campus
          </Link>
          {canClose && (
            <button type="button" className="rnd-button" onClick={() => window.close()}>
              Cerrar pestaña
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecursoNoDisponible;
